import { AvailablePaymentCardDto } from '@interfaces/models';
import { create } from 'zustand';

export interface CardsStore {
  cards: AvailablePaymentCardDto[];
  setCards: (cards: AvailablePaymentCardDto[]) => void;
  removeCard: (id: string) => void;
  clearCards: () => void;
}

const byDefaultAndValidity = (a: AvailablePaymentCardDto, b: AvailablePaymentCardDto) => {
  if (a.cardExpirationYear === b.cardExpirationYear) {
    return a.cardExpirationMonth.localeCompare(b.cardExpirationMonth);
  }
  return a.cardExpirationYear.localeCompare(b.cardExpirationYear);
};

export const useCardsStore = create<CardsStore>((set) => ({
  cards: [],
  setCards: (cards: AvailablePaymentCardDto[]) => {
    set({ cards: cards.sort(byDefaultAndValidity) });
  },
  removeCard: (id: string) => {
    set((state) => {
      const cards = state.cards.filter((card) => card.paymentMethodId !== id);
      const sortedCards = cards.sort(byDefaultAndValidity);
      return { cards: sortedCards };
    });
  },
  clearCards: () => {
    set({ cards: [] });
  },
}));
